import { registerItemRenderer } from "./index";
import { renderShelf } from "./shelf";
import { renderRail } from "./rail";
import { renderBracket } from "./bracket";
import { renderPerforatedPanel } from "./perforated-panel";
import { renderFoldingTable } from "./folding-table";
import { renderCabinet } from "./cabinet";
import { renderModuleHolder } from "./module-holder";

export const registerAllItemRenderers = () => {
    registerItemRenderer("полка", renderShelf);
    registerItemRenderer("рейлинг", renderRail);
    registerItemRenderer("кронштейн", renderBracket);
    registerItemRenderer("перфопанель", renderPerforatedPanel);
    registerItemRenderer("откидной стол", renderFoldingTable);
    registerItemRenderer("верстак", renderFoldingTable);
    registerItemRenderer("шкафчик", renderCabinet);
    registerItemRenderer("модуль", renderModuleHolder);
    registerItemRenderer("держатель", renderModuleHolder);
};
